import React, { useState } from "react";
import { siteConfig } from "../../config/siteConfig";
import Eyebrow from "../ui/Eyebrow";
import Reveal from "../ui/Reveal";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const { faq } = siteConfig;
  const items = Array.isArray(faq?.items) ? faq.items : [];

  // JSON-LD FAQPage — parité 1:1 avec les Q/A config-driven affichées.
  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: { "@type": "Answer", text: item.answer },
    })),
  };

  return (
    <section id="faq" className="relative bg-mesh py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center max-w-3xl mx-auto mb-14">
          {faq?.eyebrow ? (
            <Eyebrow as="div" className="justify-center">
              {faq.eyebrow}
            </Eyebrow>
          ) : null}
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-slate-900 mt-4 mb-6">
            {faq?.title}
          </h2>
          {faq?.subtitle ? (
            <p className="text-lg md:text-xl text-pretty leading-snug text-slate-600">
              {faq.subtitle}
            </p>
          ) : null}
        </Reveal>

        <div className="space-y-4">
          {items.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <Reveal
                key={index}
                index={index}
                className="card-interactive bg-white rounded-2xl border border-slate-200 overflow-hidden"
              >
                <h3 className="m-0">
                  <button
                    type="button"
                    id={`faq-button-${index}`}
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    aria-expanded={isOpen}
                    aria-controls={`faq-panel-${index}`}
                    className="w-full px-6 py-5 flex items-center justify-between gap-4 text-left rounded-2xl focus:outline-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 focus-visible:ring-offset-white"
                  >
                    <span className="font-semibold text-slate-900 text-lg">
                      {item.question}
                    </span>
                    <span
                      className={`flex-shrink-0 w-8 h-8 rounded-xl flex items-center justify-center transition-colors duration-200 ${
                        isOpen
                          ? "bg-indigo-50 text-indigo-700 ring-1 ring-inset ring-indigo-100"
                          : "bg-slate-100 text-slate-500"
                      }`}
                    >
                      <svg
                        className={`w-5 h-5 transition-transform duration-200 ease-out ${
                          isOpen ? "rotate-180" : ""
                        }`}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        aria-hidden="true"
                        focusable="false"
                      >
                        <path d="M6 9l6 6 6-6" />
                      </svg>
                    </span>
                  </button>
                </h3>
                <div
                  id={`faq-panel-${index}`}
                  role="region"
                  aria-labelledby={`faq-button-${index}`}
                  hidden={!isOpen}
                  className={isOpen ? "px-6 pb-5 animate-slideDown" : "px-6 pb-5"}
                >
                  <div className="pt-2 border-t border-slate-100">
                    <p className="text-slate-600 leading-relaxed">{item.answer}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
    </section>
  );
};

export default FAQ;
